import './users-page.scss';

import { CheckBox, Preloader } from '~shared/ui';

import { useUsers } from './use-users';
import { UsersFilter } from './users.filter';
import { UsersItem } from './users.item';
import { UsersPages } from './users.pages';

export function UserPage() {
	const {
		search,
		list,
		isPending,
		page,
		total,
		selected,
		onSearch,
		onChangeSection,
		onChangePage,
		onSelect,
		onSelectAll,
	} = useUsers();

	return (
		<div className="users-page">
			<h4>Пользователи</h4>
			<UsersFilter search={search} onChange={onSearch} />
			<div className="table-overlay">
				<table className="table">
					<thead>
						<tr>
							<th>
								<CheckBox onChange={onSelectAll} checked={selected.length === list.length} />
							</th>
							<th>ФИО</th>
							<th>Должность</th>
							<th>Участок</th>
						</tr>
					</thead>
					<tbody>
						{isPending ? (
							<tr>
								<td colSpan={4}>
									<Preloader />
								</td>
							</tr>
						) : (
							<>
								{list.map(itm => (
									<UsersItem
										key={itm.id}
										user={itm}
										onChange={onChangeSection}
										selected={selected.includes(itm.id!)}
										onSelect={onSelect}
									/>
								))}
							</>
						)}
					</tbody>
				</table>
			</div>
			<UsersPages page={page} total={total} onChange={onChangePage} />
		</div>
	);
}
